export const monthChangePrice = '% thay đổi giá 1M';
export const yearChangePrice = '% thay đổi giá 1Y';
export const monthChangePersent = '%Giá - %VNI (1M)';
export const yearChangePersent ='%Giá - %VNI (1Y)';
export const lowestMonthPrice = 'Đáy 1M';
export const highestMonthPrice = 'Đỉnh 1M';
export const lowestYearPrice = 'Đáy 1Y';
export const highestYearPrice = 'Đỉnh 1Y';
export interface PriceBoard {
    [monthChangePrice]: number;
    [yearChangePrice]: number;
    [monthChangePersent]: number;
    [yearChangePersent]: number;
    [lowestMonthPrice]: number;
    [highestMonthPrice]: number;
    [lowestYearPrice]: number;
    [highestYearPrice]: number;
}
